<template>
  <div class="f-column flex-1 no-shrink ma-4">
    <div
      class="gw_input_wrapper"
      :class="{ gw_input_error: l_text.length > 500 }"
    >
      <div class="gw_input_label">
        {{ $t('common.note') }}
      </div>
      <textarea
        ref="note"
        contenteditable="true"
        :value="l_text"
        style="--input-height: 8rem"
        class="textarea_note"
        @input="handleInput"
        @keydown.stop.enter.exact.prevent="handleUpdate()"
        @keydown.stop.enter.shift.exact.prevent="l_text += '\n'"
      ></textarea>
      <div class="gw_input_error_message">
        {{
          $t(`messages.note_too_many_characters`, {
            max_chars: 500,
          })
        }}
      </div>
    </div>

    <div
      class="ml-auto mt-4 gw_btn gw_btn-v1 gw_btn_primary textarea_btn"
      @click="handleUpdate()"
    >
      <i class="mr-2 mdi text-semi-large mdi-content-save"></i>
      {{ $t('btn.update') }}
    </div>
  </div>
</template>

<script>
// TODO unify tables details

import table_mix from '@/components/DataTables/table_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'SavedFiltersTableV1RowDetail',
  mixins: [table_mix, float_mix],
  props: {
    text: String,
  },
  emits: ['update:text'],
  data() {
    return {
      l_text: '',
    }
  },
  mounted() {
    this.l_text = this.text
  },
  methods: {
    handleInput(el) {
      this.l_text = el.target.value
    },
    handleUpdate() {
      this.$emit('update:text', this.l_text)
    },
  },
}
</script>
